import { ActionType, createAsyncAction } from 'typesafe-actions';
import { FormItem } from 'widgets/MenuEditor/hooks/useInitialValues';

import { LocaleType } from 'utils/translations';

import { MenuScheme } from './scheme';

export const getMenuAsyncAction = createAsyncAction(
  '@menu/GET_MENU_START',
  '@menu/GET_MENU_SUCCESS',
  '@menu/GET_MENU_FAILURE',
)<{ locale: LocaleType }, MenuScheme, Error>();

export const updateMenuAsyncAction = createAsyncAction(
  '@menu/UPDATE_MENU_START',
  '@menu/UPDATE_MENU_SUCCESS',
  '@menu/UPDATE_MENU_FAILURE',
)<{ locale: LocaleType; items: { [key: number]: FormItem } }, void, Error>();

export type MenuActions =
  | ActionType<typeof getMenuAsyncAction>
  | ActionType<typeof updateMenuAsyncAction>;
